<div class="question-form__heatmap">
  @if (surveyEditorService.surveyEditor$().activeQuestion; as activeQuestion) {
    <span class="question-form__heatmap-title fs__md fw__600">Upload Image</span>

    @if (heatmapImage$()) {
      <div class="question-form__heatmap-media" [class.deleted]="heatmapImage$().deleted">
        @if (heatmapImage$().url$ | async; as url) {
          <button mat-icon-button title="Delete" class="media-delete__btn" color="warn" (click)="onDelete(heatmapImage$().id)">
            <fa-icon [icon]="faTrashCan"></fa-icon>
          </button>

          <img eiq-media-broken [id]="heatmapImage$().id" [alt]="heatmapImage$().name" [ngSrc]="url" fill class="hetmap__image" />
        }
      </div>
    } @else {
      <eiq-file-uploader [uploading]="uploading$()" (uploaded)="onUploadHeatmapImage($event)"></eiq-file-uploader>
    }

    <div class="question-form__heatmap-settings">
      <span class="question-form__heatmap-title fs__md fw__600">Choose min and max number of selected areas.</span>

      <form [formGroup]="activeQuestion" class="question-form__heatmap-form">
        <div class="editor-question-form__input">
          <span class="label">Min</span>
          <mat-form-field appearance="outline">
            <input matInput type="number" formControlName="minLength" />
          </mat-form-field>
        </div>

        <div class="editor-question-form__input">
          <span class="label">Max</span>
          <mat-form-field appearance="outline">
            <input matInput type="number" formControlName="maxLength" />
            <mat-hint>Setting 0 on max means infinite selection are allowed</mat-hint>
          </mat-form-field>
        </div>
      </form>

      <span class="question-form__heatmap-title fs__md fw__600"
        >Please choose how the stimulus will fit the screen. This setting will apply to all devices.</span
      >

      <form [formGroup]="activeQuestion" class="question-form__heatmap-form">
        <div class="editor-question-form__input">
          <span class="label">Image fit</span>
          <mat-form-field appearance="outline">
            <mat-select formControlName="imageFit">
              <mat-option [value]="'contain'">Contain</mat-option>
              <mat-option [value]="'cover'">Cover</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="editor-question-form__input">
          <span class="label">Height</span>
          <mat-form-field appearance="outline">
            <input matInput type="number" formControlName="imageHeight" editorAutoFocus block="nearest" autocomplete="off" />
          </mat-form-field>
        </div>
        <div class="editor-question-form__input">
          <span class="label">Width</span>
          <mat-form-field appearance="outline">
            <input matInput type="number" formControlName="imageWidth" editorAutoFocus block="nearest" autocomplete="off" />
          </mat-form-field>
        </div>
      </form>
    </div>
  }
</div>
